import { sanitize } from 'isomorphic-dompurify';
import { type HTMLAttributes } from 'react';

import { memoWithDisplayName } from '@/packages/react-utils/memoWithDisplayName';

type DangerouslyInnerHTMLElementProps = Omit<HTMLAttributes<HTMLDivElement>, 'dangerouslySetInnerHTML'> & {
  html: string;
};

export const DangerouslyInnerHTMLElement = memoWithDisplayName<DangerouslyInnerHTMLElementProps>(props => {
  const { html, ...restProps } = props;

  return (
    <div
      {...restProps}
      dangerouslySetInnerHTML={{ __html: sanitize(html) }} /* eslint-disable-line react/no-danger */
    />
  );
}, 'DangerouslyInnerHTMLElement');
